import { render, staticRenderFns } from "./LoanNotYetPaidWidget.vue?vue&type=template&id=1327fa64&scoped=true&"
import script from "./LoanNotYetPaidWidget.vue?vue&type=script&lang=ts&"
export * from "./LoanNotYetPaidWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1327fa64",
  null
  
)

export default component.exports